import * as actionTypes from './actionTypes'
import { LOGOUT_USER } from '../user/actionTypes'

const initialState = {
    productList: { products: [], total: 0, pageSize: 0, error: null, loading: false },
    productOfferList: { products: [], total: 0, pageSize: 0, error: null, loading: false },
    productStoresList: { productStores: [], total: 0, error: null, loading: false },
    updateProductStoresStock: { minStock: null, error: null, loading: false },
    activeProduct: { total: 0, product: null, error: null, loading: false },
    newProduct: { product: null, error: null, loading: false },
    updateProduct: { product: null, error: null, loading: false },
    deleteProduct: { product: null, error: null, loading: false },

    productOrdersList: { orders: [], total: 0, pageSize: 0, error: null, loading: false },
    newProductOrder: { order: null, error: null, loading: false },
    deleteProductOrder: { order: null, error: null, loading: false }
}

export default (state = initialState, action) => {
    switch (action.type) {

        case actionTypes.FETCH_PRODUCTS:
            return {
                ...state,
                productList: {
                    ...state.productList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_PRODUCTS_SUCCESS:
            return {
                ...state,
                productList: {
                    products: action.payload.products,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_PRODUCTS_FAILURE:
            return {
                ...state,
                productList: {
                    products: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_PRODUCTS:
            return { ...state, productList: initialState.productList }

        case actionTypes.FETCH_PRODUCTS_OFFER:
            return {
                ...state,
                productOfferList: {
                    ...state.productOfferList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_PRODUCTS_OFFER_SUCCESS:
            return {
                ...state,
                productOfferList: {
                    products: action.payload.products,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_PRODUCTS_OFFER_FAILURE:
            return {
                ...state,
                productOfferList: {
                    products: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_PRODUCTS_OFFER:
            return { ...state, productOfferList: initialState.productOfferList }

        case actionTypes.FETCH_PRODUCTS_STORES:
            return {
                ...state,
                productStoresList: {
                    ...state.productStoresList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_PRODUCTS_STORES_SUCCESS:
            return {
                ...state,
                productStoresList: {
                    productStores: action.payload.productStores,
                    total: action.payload.total,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_PRODUCTS_STORES_FAILURE:
            return {
                ...state,
                productStoresList: {
                    productStores: [],
                    total: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_PRODUCTS_STORES:
            return { ...state, productStoresList: initialState.productStoresList }



        case actionTypes.FETCH_PRODUCT:
            return { ...state, activeProduct: { product: null, error: null, loading: true } }

        case actionTypes.FETCH_PRODUCT_SUCCESS:
            return { ...state, activeProduct: { product: action.payload.product, error: null, loading: false } }

        case actionTypes.FETCH_PRODUCT_FAILURE:
            return { ...state, activeProduct: { product: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_PRODUCT:
            return { ...state, activeProduct: initialState.activeProduct }



        case actionTypes.CREATE_PRODUCT:
            return {
                ...state,
                newProduct: {
                    product: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_PRODUCT_SUCCESS:
            return {
                ...state,
                newProduct: {
                    product: action.payload.product,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_PRODUCT_FAILURE:
            return {
                ...state,
                newProduct: {
                    product: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_PRODUCT:
            return { ...state, newProduct: initialState.newProduct }




        case actionTypes.UPDATE_PRODUCT:
            return { ...state, updateProduct: { product: null, error: null, loading: true } }

        case actionTypes.UPDATE_PRODUCT_SUCCESS:
            return { ...state, updateProduct: { product: action.payload.product, error: null, loading: false } }

        case actionTypes.UPDATE_PRODUCT_FAILURE:
            return { ...state, updateProduct: { product: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_PRODUCT:
            return { ...state, updateProduct: initialState.updateProduct }

        case actionTypes.UPDATE_PRODUCT_STORES_STOCK:
            return { ...state, updateProductStoresStock: { minStock: null, error: null, loading: true } }

        case actionTypes.UPDATE_PRODUCT_STORES_STOCK_SUCCESS:
            return { ...state, updateProductStoresStock: { minStock: action.payload.minStock, error: null, loading: false } }

        case actionTypes.UPDATE_PRODUCT_STORES_STOCK_FAILURE:
            return { ...state, updateProductStoresStock: { minStock: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_UPDATE_PRODUCT_STORES_STOCK:
            return { ...state, updateProductStoresStock: initialState.updateProductStoresStock }



        case actionTypes.DELETE_PRODUCT:
            return { ...state, deleteProduct: { product: null, error: null, loading: true } }

        case actionTypes.DELETE_PRODUCT_SUCCESS:
            return { ...state, deleteProduct: { product: action.payload.product, error: null, loading: false } }

        case actionTypes.DELETE_PRODUCT_FAILURE:
            return { ...state, deleteProduct: { product: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_PRODUCT:
            return { ...state, deleteProduct: initialState.deleteProduct }



        case actionTypes.FETCH_PRODUCT_ORDERS:
            return {
                ...state,
                productOrdersList: {
                    ...state.productOrdersList,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.FETCH_PRODUCT_ORDERS_SUCCESS:
            return {
                ...state,
                productOrdersList: {
                    orders: action.payload.orders,
                    total: action.payload.total,
                    pageSize: action.payload.pageSize,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.FETCH_PRODUCT_ORDERS_FAILURE:
            return {
                ...state,
                productOrdersList: {
                    orders: [],
                    total: 0,
                    pageSize: 0,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_PRODUCT_ORDERS:
            return { ...state, productOrdersList: initialState.productOrdersList }


        case actionTypes.CREATE_PRODUCT_ORDER:
            return {
                ...state,
                newProductOrder: {
                    order: null,
                    error: null,
                    loading: true
                }
            }

        case actionTypes.CREATE_PRODUCT_ORDER_SUCCESS:
            return {
                ...state,
                newProductOrder: {
                    order: action.payload.order,
                    error: null,
                    loading: false
                }
            }

        case actionTypes.CREATE_PRODUCT_ORDER_FAILURE:
            return {
                ...state,
                newProductOrder: {
                    order: null,
                    error: action.payload.error,
                    loading: false
                }
            }

        case actionTypes.RESET_CREATE_PRODUCT_ORDER:
            return { ...state, newProductOrder: initialState.newProductOrder }

        case actionTypes.DELETE_PRODUCT_ORDER:
            return { ...state, deleteProductOrder: { order: null, error: null, loading: true } }

        case actionTypes.DELETE_PRODUCT_ORDER_SUCCESS:
            return { ...state, deleteProductOrder: { order: action.payload.order, error: null, loading: false } }

        case actionTypes.DELETE_PRODUCT_ORDER_FAILURE:
            return { ...state, deleteProductOrder: { order: null, error: action.payload.error, loading: false } }

        case actionTypes.RESET_DELETE_PRODUCT_ORDER:
            return { ...state, deleteProductOrder: initialState.deleteProductOrder }
        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/product/reducer.js